// extracted by mini-css-extract-plugin
module.exports =  {"styledModal":"TogglesModal-module__styledModal--uPnrV","container":"TogglesModal-module__container--sYa3_","row":"TogglesModal-module__row--wDdjy"};